import * as React from 'react'
import cx from 'classnames'
import styles from './AvatarProgress.sass'
import RadialProgress from 'components/RadialProgress'

interface AvatarProgressProps {
  size: number
  thickness?: number
  color?: string
  /**
   * If null, does not render the progress.
   */
  progress: number | null
  children?: React.ReactNode
}

export default function AvatarProgress({
  size,
  progress,
  children,
  color,
  thickness = 2,
}: AvatarProgressProps) {
  return (
    <div className={cx(styles.root)} style={{ fontSize: size }}>
      {progress !== null && (
        <div className={styles.progress}>
          <RadialProgress
            progress={progress}
            size={size}
            thickness={thickness}
            roundedLine
            stroke={color}
          />
        </div>
      )}
      {children}
    </div>
  )
}
